import { CheckCircle, Phone, Star, Users } from 'lucide-react';
import React from 'react';

/**
 * Metric Cards Component
 * Based on conversation-mockup.html design
 * Displays statistics for recruitment results
 *
 * @param {Object} props
 * @param {number} props.candidatesFound - Total candidates found
 * @param {number} props.highRated - High rated candidates (90%+)
 * @param {number} props.contacted - Contacted candidates
 * @param {number} props.perfectMatches - Perfect match candidates
 */
export function MetricCards({
  candidatesFound = 0,
  highRated = 0,
  contacted = 0,
  perfectMatches = 0
}) {
  const metrics = [
    {
      icon: Users,
      value: candidatesFound,
      label: 'Candidates Found',
      color: 'blue',
      bgColor: 'bg-blue-100',
      iconColor: 'text-blue-600'
    },
    {
      icon: Star,
      value: highRated,
      label: 'High Rated (90%+)',
      color: 'green',
      bgColor: 'bg-green-100',
      iconColor: 'text-green-600'
    },
    {
      icon: Phone,
      value: contacted,
      label: 'Contacted',
      color: 'purple',
      bgColor: 'bg-purple-100',
      iconColor: 'text-purple-600'
    },
    {
      icon: CheckCircle,
      value: perfectMatches,
      label: 'Perfect Matches',
      color: 'yellow',
      bgColor: 'bg-yellow-100',
      iconColor: 'text-yellow-600'
    }
  ];

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 mb-6">
      {metrics.map((metric, index) => (
        <div
          key={index}
          className="bg-white rounded-lg shadow-sm border border-gray-200 p-4 hover:shadow-md transition"
        >
          <div className="flex items-center justify-between mb-2">
            <div className={`w-10 h-10 ${metric.bgColor} rounded-lg flex items-center justify-center`}>
              <metric.icon className={`w-5 h-5 ${metric.iconColor}`} />
            </div>
          </div>
          <div className="text-2xl font-bold text-gray-900">{metric.value}</div>
          <div className="text-sm text-gray-600">{metric.label}</div>
        </div>
      ))}
    </div>
  );
}

export default MetricCards;























